import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCamera5: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="camera-5, action cam, GoPro"><path d="M6.75 16.25H9.25M9.75 4.75H2.75V20.25H21.25V16.25M12.75 4.75H21.25V13.253H12.75V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17 9V8.99M17.25 9C17.25 9.13807 17.1381 9.25 17 9.25C16.8619 9.25 16.75 9.13807 16.75 9C16.75 8.86193 16.8619 8.75 17 8.75C17.1381 8.75 17.25 8.86193 17.25 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconCamera5;
